interface AvatarProps {
  username: string;
  size?: 'sm' | 'md' | 'lg';
}

const COLORS = [
  '#4ade80', // green
  '#60a5fa', // blue
  '#f472b6', // pink
  '#facc15', // yellow
  '#a78bfa', // purple
  '#fb923c', // orange
  '#2dd4bf', // teal
  '#f87171', // red
];

function hashUsername(name: string): number {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash);
}

const SIZE_MAP = {
  sm: { px: 32, text: 'text-xs' },
  md: { px: 48, text: 'text-base' },
  lg: { px: 72, text: 'text-xl' },
};

export default function Avatar({ username, size = 'md' }: AvatarProps) {
  const initials = username.slice(0, 2).toUpperCase();
  const bg = COLORS[hashUsername(username) % COLORS.length];
  const { px, text } = SIZE_MAP[size];

  return (
    <div
      className={`rounded-full flex items-center justify-center font-bold text-white shrink-0 ${text}`}
      style={{ width: px, height: px, backgroundColor: bg }}
    >
      {initials}
    </div>
  );
}
